import React from "react";
import { Provider } from "react-redux";
import { AppProvider } from "./Common/AppContext";
import { SellerAuthProvider } from "./Common/SellerAuthContext";

export default function AppProviders({ children, store }) {
  return (
    <Provider store={store}>
      <AppProvider>
        <SellerAuthProvider>{children}</SellerAuthProvider>
      </AppProvider>
    </Provider>
  );
}
